module.exports = __webpack_public_path__ + "img/logo.8ded9ff1.svg";